'use client';

import { useEffect } from 'react';

// Registers the Web Push service worker and keeps it auto-updating so a deploy
// never requires the user to touch anything. When a NEW service worker takes
// over an EXISTING one, we reload once to run the fresh version. (First-ever
// install has no previous controller, so it does not reload.)
export default function ServiceWorkerRegister() {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    const hadController = !!navigator.serviceWorker.controller;
    let reloaded = false;
    const onControllerChange = () => {
      if (reloaded || !hadController) return; // don't reload on the first install
      reloaded = true;
      window.location.reload();
    };
    navigator.serviceWorker.addEventListener('controllerchange', onControllerChange);

    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        reg.update().catch(() => {}); // check for a newer SW on every load
      })
      .catch(() => {
        /* registration failures are non-fatal */
      });

    return () => navigator.serviceWorker.removeEventListener('controllerchange', onControllerChange);
  }, []);
  return null;
}
